import Resource from '@/services/resources/common';

export default class ConditionTypeResource extends Resource {
  constructor(entrypoint = '/condition_types', alias = 'ConditionType') {
    super(entrypoint, alias);
  }
}
